import Axios from "axios";
import {json} from "body-parser";
import React, {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import {useHistory} from "react-router-dom";
import {useAppContext} from "../../context/state";
import {storage, useRequest} from "../../utils";

var axios = require("axios");
var FormData = require("form-data");
// import "../../assets/css/plugins/forms/wizard.css";
import ScriptTag from "react-script-tag";
// const Demo = (props) => (
//   <ScriptTag
//     type="text/javascript"
//     src="../../assets/js/scripts/forms/wizard-steps.js"
//   />
// );

// var fs = require("fs");
//locall
// import "./AddProduct.css";
import utils from "../../components/toastify/toastify";

const addClientUser = (props) => {
    const [phone_number, set_phone_number] = useState("");
    const [name, set_name] = useState("");
    const [password, set_password] = useState("");
    // const [email, set_email] = useState("");
    // const [user_name, set_user_name] = useState("");
    // const [roll, set_roll] = useState("");

    let history = useHistory();

    const [add_user_error, add_user_loading, add_user_data, add_user_function] =
        useRequest({
            method: "post",
            url: "/add_client_user",
            body: {
                country_code: "98",
                phone_number: String(Number(phone_number)),
                name,
                password,
                // email,
                // user_name,
                // roll,
            },
            isFunction: true,
        });

    return (
        <div className="AddProductContainer">
            <div class="content-header row">
                <div class="content-header-left col-12 mb-2 mt-1">
                    <div class="row breadcrumbs-top">
                        <div class="col-12">
                            <h5 class="content-header-title float-left pr-1">مسیر</h5>
                            <div class="breadcrumb-wrapper">
                                <ol class="breadcrumb p-0 mb-0">
                                    <li class="breadcrumb-item">
                                        <a href="index.html">
                                            <i class="bx bx-home-alt"></i>
                                        </a>
                                    </li>
                                    <li class="breadcrumb-item active">افزودن کاربر جدید</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <Wizard /> */}
            {/* <!-- Basic Inputs start --> */}
            <section id="basic-input">
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-header">
                                <h4 class="card-title">افزودن کاربر جدید</h4>
                            </div>

                            <div class="card">
                                {/* <div class="card-header">
                  <h4 class="card-title">ترم ها</h4>
                </div> */}
                                <div class="card-content">
                                    <div class="card-body">
                                        <form action="#" class="contact-repeater">
                                            <div data-repeater-list="contact">
                                                <div
                                                    class="row justify-content-between"
                                                    data-repeater-item
                                                >
                                                    <div class="col-md-6 col-12 form-group d-flex align-items-center">
                                                        <div
                                                            style={{
                                                                display: "flex",
                                                                flexDirection: "column",
                                                                width: "100%",
                                                            }}
                                                        >
                                                            {/*<div*/}
                                                            {/*  style={{*/}
                                                            {/*    display: "flex",*/}
                                                            {/*    marginBottom: "10px",*/}
                                                            {/*  }}*/}
                                                            {/*>*/}
                                                            {/*  <input*/}
                                                            {/*    type="text"*/}
                                                            {/*    style={{*/}
                                                            {/*      marginBottom: "10px",*/}
                                                            {/*    }}*/}
                                                            {/*    class="form-control"*/}
                                                            {/*    placeholder="نام کاربری"*/}
                                                            {/*    value={user_name}*/}
                                                            {/*    onChange={(e) =>*/}
                                                            {/*      set_user_name(e.target.value)*/}
                                                            {/*    }*/}
                                                            {/*  />*/}
                                                            {/*</div>*/}
                                                            {/*<fieldset class="form-group">*/}
                                                            {/*  <select*/}
                                                            {/*    class="custom-select"*/}
                                                            {/*    id="customSelect"*/}
                                                            {/*    value={roll}*/}
                                                            {/*    onChange={(e) => set_roll(e.target.value)}*/}
                                                            {/*  >*/}
                                                            {/*    <option selected value="">*/}
                                                            {/*      سطح دسترسی کاربر را انتخاب کنید*/}
                                                            {/*    </option>*/}
                                                            {/*    <option value="admin">ادمین اصلی</option>*/}
                                                            {/*    <option value="support">پشتیبانی</option>*/}
                                                            {/*    <option value="developer">توسعه دهنده</option>*/}
                                                            {/*    <option value="financial">مالی</option>*/}
                                                            {/*  </select>*/}
                                                            {/*</fieldset>*/}

                                                            <input
                                                                type="number"
                                                                class="form-control"
                                                                style={{
                                                                    marginBottom: "10px",
                                                                }}
                                                                placeholder="شماره همراه"
                                                                value={phone_number}
                                                                onChange={(e) =>
                                                                    set_phone_number(e.target.value)
                                                                }
                                                            />
                                                            <input
                                                                type="text"
                                                                style={{
                                                                    marginBottom: "10px",
                                                                }}
                                                                class="form-control"
                                                                placeholder="نام"
                                                                value={name}
                                                                onChange={(e) => set_name(e.target.value)}
                                                            />
                                                            <input
                                                                type="password"
                                                                style={{
                                                                    marginBottom: "10px",
                                                                }}
                                                                class="form-control"
                                                                placeholder="رمز عبور"
                                                                value={password}
                                                                onChange={(e) => set_password(e.target.value)}
                                                            />
                                                            {/*<input*/}
                                                            {/*  type="email"*/}
                                                            {/*  class="form-control"*/}
                                                            {/*  placeholder="ایمیل"*/}
                                                            {/*  value={email}*/}
                                                            {/*  onChange={(e) => set_email(e.target.value)}*/}
                                                            {/*/>*/}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                            <button
                                onClick={() => {
                                    var $white = "#fff";
                                    $.blockUI({
                                        message:
                                            '<div class="semibold"><span class="bx bx-reset icon-spin text-left align-middle" style="padding-bottom:1.75px"></span>&nbsp; در حال انجام عملیات ...</div>',

                                        // timeout: 2000, //unblock after 2 seconds
                                        overlayCSS: {
                                            backgroundColor: $white,
                                            opacity: 0.8,
                                            cursor: "wait",
                                        },
                                        css: {
                                            border: 0,
                                            padding: 0,
                                            backgroundColor: "transparent",
                                        },
                                    });
                                    add_user_function()
                                        .then(() => {
                                            history.push("/dashboard/getUsers/");
                                            $.unblockUI();
                                        })
                                        .catch(() => {
                                            utils.showAlert("خطایی به وجود آمده است یا شماره تلفن همراه تکراری است", "error");
                                            $.unblockUI();
                                        });
                                }}
                                style={{
                                    marginTop: "-2rem",
                                    marginRight: "25px",
                                    width: "fit-content",
                                }}
                                type="button"
                                class="btn btn-success mr-1 mb-1 "
                            >
                                افزودن کاربر جدید
                            </button>
                        </div>
                    </div>
                </div>
            </section>
            {/* <!-- Basic Inputs end --> */}
            {/* <Demo /> */}
        </div>
    );
};

export {addClientUser};
